import React, { useState } from "react"
import { useStaticQuery, graphql } from "gatsby"
import styled, { css } from "styled-components"
import { BackgroundImage } from "@abmg-components"

import HeroCaption from "./hero-caption"
import NMNLogoWhiteText from "@images/global/NMN-logo-white-text.svg"

const size = {
  tablet: 950,
  mobile: 600,
}
const below = Object.keys(size).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (max-width: ${size[label]}px) {
      ${css(...args)};
    }
  `
  return acc
}, {})

const above = Object.keys(size).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (min-width: ${size[label]}px) {
      ${css(...args)};
    }
  `
  return acc
}, {})

const HeroWrapper = styled.div`
  position: relative;
  height: ${props => (props.setHeight ? props.setHeight : "720px")};
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding-bottom: 40px;
  ${below.tablet`padding-bottom: 40px; height: 440px;`}
`
const Container = styled.div`
  margin: 0px auto;
  width: 100%;
  max-width: 1248px;
  padding: 0px 0px 0px 48px;
  ${below.mobile`
    padding: 0 24px;
    
  `}

  h1 {
    display: block;
    font-family: "Source Sans Pro", sans-serif;
    color: white;
    max-width: 900px;
    letter-spacing: -0.05em;
    font-size: 136px;
    line-height: 152px;
    font-weight: 900;

    ${below.tablet`
    font-size: 88px;
    line-height: 96px;
    letter-spacing: initial;
    max-width: 616px;

  `}

    @media (max-width:735px) {
      font-size: 68px;
      line-height: 88px;
      max-width: 449px;
    }
    ${below.mobile`
    font-size: 68px;
    line-height: 72px;
    max-width: 328px;
    
  `}
    &.mobile-headline {
      display: none;
      ${below.mobile`
      display: block;
      @media screen and (max-width: 360px) {
      max-width: 224px;
      }
      `}
    }
    &.desktop-headline {
      ${below.mobile`display: none;`}
    }
  }
`

const Overhead = styled.h2`
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  text-transform: uppercase;
  color: #ecc94b;
  margin-bottom: 8px;
  max-width: 664px;
  ${below.mobile`
     font-size: 18px;
    line-height: 24px;
    `}
`
const Overlay = styled.div`
  position: absolute;
  bottom: 0;
  z-index: -1;
  width: 100%;
  height: 70%;
  background: linear-gradient(
    0deg,
    rgba(0, 0, 0, 0.6) 0%,
    rgba(135, 135, 135, 0) 100%
  );
`

const NMNLogoImage = styled.div`
  img,
  svg {
    width: 144px;
    height: 77px;
    margin-bottom: 16px;
    ${above.mobile`
  width:174px;
  height:93px;
  `}

    ${above.tablet`
  width:232px;
  height:124px;
  `}
  }
`

const HomeHeader = props => {
  const [isToggled, setToggle] = useState(false)
  const data = useStaticQuery(graphql`
    query DefaultHeroQuery {
      Hero: file(relativePath: { regex: "/global/hero-default.jpg/" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH)
        }
      }
    }
  `)

  return (
    <HeroWrapper setHeight={props.setHeight}>
      <BackgroundImage
        backgroundImage={
          props.customHero
            ? props.customHero
            : data.Hero.childImageSharp.gatsbyImageData
        }
        objectPosition={props.objectPosition ? props.objectPosition : null}
      />
      <Container>
        {props.overhead && <Overhead>{props.overhead}</Overhead>}
        {props.NMNLogo && !isToggled && (
          // <NMNLogoImage src={NMNLogoWhite} alt="National Mortgage News Logo" />
          <NMNLogoImage>
            <img
              src={NMNLogoWhiteText}
              alt="National Mortgage News Best Morgage Companies to Work for 2024 Award"
            />
          </NMNLogoImage>
        )}
        {props.headline && !isToggled && (
          <h1
            className={`${
              props.mobileHeadline ? "desktop-headline" : undefined
            }`}
          >
            {props.headline}
          </h1>
        )}
        {props.mobileHeadline && !isToggled && (
          <h1
            className={`mobile-headline ${
              props.headlineSize ? props.headlineSize : "hero-160"
            }`}
          >
            {props.mobileHeadline}
          </h1>
        )}
      </Container>
      {props.caption && (
        <HeroCaption
          caption={props.caption}
          isToggled={isToggled}
          setToggle={setToggle}
        />
      )}
      {props.overlay && !isToggled && <Overlay />}
    </HeroWrapper>
  )
}

export default HomeHeader
